import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

export async function getReporteVentas(ids_dia: number[]) {
  try {
    const params: Record<string, string> = {};
    if (ids_dia && ids_dia.length > 0) {
      params.ids_dia = ids_dia.join(',');
    }
    const response = await axios.get(`${API_URL}cortesias/reporte-ventas`, { params });
    return response.data?.doc?.data ?? [];
  } catch (error) {
    console.error('Error al obtener el reporte de ventas:', error);
    throw error;
  }
}
